import { useState } from 'react';
import { Role } from '../../types/permissions';
import { useRoles } from './useRoles';
import { useRoleForm } from './useRoleForm';
import { roleUtils } from '../../utils/permissions';

export const useRoleManagement = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedRole, setSelectedRole] = useState<Role | null>(null);
  
  const { roles, loading, createRole, deleteRole } = useRoles();
  const roleForm = useRoleForm();

  const openModal = () => {
    setShowModal(true);
    roleForm.resetForm();
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedRole(null);
    roleForm.resetForm();
  };

  const handleCreateRole = async () => {
    if (!roleForm.validateForm()) {
      return;
    }

    roleForm.setSubmitting(true);
    const success = await createRole(roleForm.formData.name, roleForm.formData.description);
    
    if (success) {
      closeModal();
    }
    
    roleForm.setSubmitting(false);
  };

  const handleDeleteRole = async (roleId: number) => {
    const role = roleUtils.findRoleById(roles, roleId);
    if (!role) return;

    const canDelete = roleUtils.isAdminRole(role.name);
    if (!canDelete) {
      const success = await deleteRole(roleId);
      if (success && selectedRole?.id === roleId) {
        setSelectedRole(null);
      }
    }
  };

  const selectRole = (role: Role | null) => {
    setSelectedRole(role);
  };

  return {
    // Estado
    showModal,
    selectedRole,
    roles,
    loading,
    
    // Formulario
    roleForm,
    
    // Acciones
    openModal,
    closeModal,
    handleCreateRole,
    handleDeleteRole,
    selectRole
  };
};
